import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "./Breadcrumb";
import Swal from "sweetalert2";
import { API_URL, LOCATION_ID } from "..";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
const AddPolicyPage = () => {
    
  const [formData, setFormData] = useState({
    policyType: "",
    details: "",
  });
  const [error, setError] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [policies, setPolicies] = useState([]);
  const [tableError, setTableError] = useState("");
  const [showModal,setShowModal] = useState(false)
  const navigate = useNavigate();

  // Policy types for dropdown
  const policyTypes = [
    { value: "invoice-privacy", label: "Invoice Policy" },
    { value: "quote-privacy", label: "Quote Policy" },
  ];

  // React Quill toolbar configuration
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  // Fetch policies
  const fetchPolicies = async () => {
    try {
       const locationId = localStorage.getItem('locationID')
      const response = await fetch(`${API_URL}/api/user/policy?locationId=${locationId}`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      if (response.status === 200) {
        if (!Array.isArray(data.policies)) {
          throw new Error("Invalid data format: policies is not an array");
        }
        setPolicies(data.policies || []);
        setTableError("");
      } else {
        throw new Error(data.message || "Failed to fetch policies");
      }
    } catch (err) {
      console.error("Fetch policies error:", err);
      setTableError(err.message || "Unable to load policies. Please try again.");
      setPolicies([]);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message || "Unable to fetch policies",
      });
    }
  };

  // Handle dropdown change
  const handlePolicyTypeChange = (e) => {
    setFormData((prev) => ({ ...prev, policyType: e.target.value }));
    setError("");
  };

  // Handle React Quill change
  const handleEditorChange = (value) => {
    setFormData((prev) => ({ ...prev, details: value }));
    setError("");
  };

  // Validate form
  const validateForm = () => {
    if (!formData.policyType) return "Policy type is required";
    if (!formData.details.trim() || formData.details === "<p><br></p>")
      return "Policy details are required";
    return "";
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      
      const obj = {type:formData.policyType,details:formData.details,locationId: LOCATION_ID};
      

      const response = await fetch(`${API_URL}/api/user/policy`, {
        method: "POST",
        body: JSON.stringify(obj),
        headers:{
            'Content-Type' :'application/json',
            'Accept': '*/*'
        }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      if (response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Policy Added",
          text: "Policy has been added successfully",
        });
        setPolicies((prev) => [...prev, data.policy]);
        resetForm();
        setShowModal(false)
      } else {
        throw new Error(data.message || "Failed to add policy");
      }
    } catch (err) {
      console.error("Submit error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message || "Unable to save policy",
      });
    }
  };

  // Handle preview
  const handlePreview = () => {
    if (!formData.details.trim() || formData.details === "<p><br></p>") {
      setError("Please enter policy details to preview");
      return;
    }
    setShowPreview(true);
  };

  // Handle edit
  const handleEdit = (id) => {
    
    navigate(`/policies/edit/${id}`);
  };

  // Handle delete
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(`${API_URL}/api/user/policy/${id}`, {
          method: "DELETE",
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        if (response.status === 200) {
          Swal.fire("Deleted!", "Policy has been deleted.", "success");
          setPolicies((prev) => prev.filter((policy) => policy.id !== id));
        } else {
          throw new Error(data.message || "Failed to delete policy");
        }
      } catch (err) {
        console.error("Delete error:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.message || "Unable to delete policy",
        });
      }
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      policyType: "",
      details: "",
    });
    setError("");
    setShowPreview(false);
  };

  // Fetch policies on mount
  useEffect(() => {
    fetchPolicies();
  }, []);

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Policies" />

        <div className="card basic-data-table">
          <div className="card-header">
            <div className="row">
              <h5 className="card-title mb-0 col-md-6">List of Policies</h5>
              <div className="col-md-6 text-end">
                <button
                  className="btn btn-primary"
                  style={{ background: "#144BD6", borderColor: "#144BD6" }}
                  onClick={() => setShowModal(!showModal)} // Ensure form is reset when opening
                >
                  Add New
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            {tableError && (
              <div className="alert alert-danger mb-3">{tableError}</div>
            )}
            <table className="table bordered-table mb-0">
              <thead>
                <tr>
                  <th scope="col">Type</th>
                  <th scope="col">Update Date</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {policies.map((policy) => (
                  <tr key={policy?.id}>
                    <td>
                      {policyTypes.find((type) => type.value === policy.type)?.label ||
                        policy.type}
                    </td>
                    <td>
                      {policy.updatedAt
                        ? new Date(policy.updatedAt).toLocaleDateString()
                        : "N/A"}
                    </td>
                    <td>
                      <button
                        className="btn btn-primary me-2"
                        onClick={() => handleEdit(policy.id)}
                      >
                        <i className="ph ph-pencil">Edit</i>
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => handleDelete(policy.id)}
                      >
                        <i className="ph ph-trash">Delete</i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {policies.length === 0 && !tableError && (
              <div className="text-center mt-3">
                <p>No policies found. Add a new policy to get started.</p>
              </div>
            )}
          </div>
        </div>

      <Modal show={showModal}  size="lg">
        <Modal.Header closeButton onClick={()=>setShowModal(false)}>
            Add New
        </Modal.Header>
        <Modal.Body>
        <div className=" basic-data-table mt-4">
        
          <div className="">
            {error && <div className="alert alert-danger mb-3">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Policy Type</label>
                <select
                  name="policyType"
                  value={formData.policyType}
                  onChange={handlePolicyTypeChange}
                  className="form-control"
                  required
                >
                  <option value="">Select Policy Type</option>
                  {policyTypes.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Policy Details</label>
                <ReactQuill
                  value={formData.details}
                  onChange={handleEditorChange}
                  modules={quillModules}
                  className="quill-editor"
                  theme="snow"
                />
              </div>
              <div className="d-flex gap-2">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ background: "#db6f2f", borderColor: "#db6f2f" }}
                >
                  Save Policy
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handlePreview}
                >
                  Preview
                </button>
              </div>
            </form>

            {/* Preview Modal */}
            {showPreview && (
              <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Policy Preview</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowPreview(false)}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div
                        dangerouslySetInnerHTML={{ __html: formData.details }}
                        className="policy-preview"
                        style={{ padding: "20px", lineHeight: "1.6" }}
                      />
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowPreview(false)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        </Modal.Body>
      </Modal>
      </MasterLayout>
    </>
  );
};

export default AddPolicyPage; 